import { useEffect, useState } from 'react'

import { toPosAmount } from '@/components/pos/posCatalog'
import { Button } from '@/components/ui/button'

/**
 * @param {object} props
 * @param {boolean} props.open
 * @param {() => void} props.onClose
 * @param {import('@/types/api').SaleLine | null} props.line
 * @param {boolean} props.disabled
 * @param {(lineId: number, unitPrice: number) => void | Promise<void>} props.onSave
 */
export function PosLinePriceModal({
  open,
  onClose,
  line,
  disabled,
  onSave,
}) {
  const [unitPrice, setUnitPrice] = useState('')
  const [saving, setSaving] = useState(false)

  useEffect(() => {
    if (!line || !open) return
    setUnitPrice(String(toPosAmount(line.unit_price)))
  }, [line, open])

  if (!open || !line) return null

  async function handleSave() {
    setSaving(true)
    try {
      await onSave(line.id, Math.max(0, Number(unitPrice) || 0))
      onClose()
    } finally {
      setSaving(false)
    }
  }

  return (
    <div
      className="pos-v2-modal-backdrop"
      role="dialog"
      aria-modal="true"
      aria-label="Override price"
      onClick={disabled || saving ? undefined : onClose}
    >
      <div
        className="w-full max-w-sm rounded-lg border bg-white p-4 shadow-xl"
        onClick={(event) => event.stopPropagation()}
      >
        <p className="text-sm font-bold text-slate-900">{line.description}</p>
        <p className="mb-3 text-xs text-slate-500">Override unit price (AED)</p>

        <input
          type="number"
          min="0"
          step="0.01"
          value={unitPrice}
          disabled={disabled || saving}
          autoFocus
          onChange={(event) => setUnitPrice(event.target.value)}
          className="mb-4 h-11 w-full rounded-md border border-input bg-white px-3 font-mono text-lg"
        />

        <div className="flex gap-2">
          <Button type="button" variant="outline" className="flex-1" disabled={disabled || saving} onClick={onClose}>
            Cancel
          </Button>
          <Button type="button" className="flex-1" disabled={disabled || saving} onClick={handleSave}>
            {saving ? 'Saving…' : 'Save'}
          </Button>
        </div>
      </div>
    </div>
  )
}
